import {
  Button,
  Grid,

  Link,

  Paper,

  Stack,
  Typography,
} from '@mui/material';
import { Box, Container, } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';



const ExciseTax = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 2290 Resource Center | Instructions, Due Dates & More"
          description="Explore Form 2290 resources for filing instructions, due dates, Schedule 1, payment options, bulk uploads, penalties, credits, amendments, and more."
          keywords=""
          canonical="resources/excise-tax/"
          ogType="article"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
        />
      }
    >
      <Container maxWidth="lg" sx={{ justifyContent: 'center', mt: 8, mb: 8 }} component="section">
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 2,
            mt: 5,
            textAlign: 'center',
          }}
        >
          <span className="highlight-container">
            <span className="highlight">Form 2290 </span>
          </span>{' '}Resource Center
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { md: 18, sm: 16, xs: 16 }, textAlign: 'center', mb: 2 }} >
          Everything You Need to Understand, Prepare, and File Form 2290
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { md: 18, sm: 16, xs: 16 }, textAlign: 'center', mb: 3 }} >
          Find clear, practical resources to help you understand Heavy Highway Vehicle Use Tax, meet filing  <br />  deadlines, choose the right payment method, handle amendments, and stay compliant.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href="#explore"
          >
            Explore Form 2290 Resources
          </Button>
        </Box>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
          scrollMarginTop: 64,
        }}
        spacing={2}
        m={0}
        mt={0}
        component="section"
        id="explore"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          {process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && (
            <DynamicBreadcrumbs />
          )}
          <Grid container spacing={3} rowSpacing={4} m={0} sx={{ justifyContent: 'center' }} >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                General Instructions
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }} >
                Start with the basics of Form 2290, including filing requirements, key terms, deadlines, and Schedule 1.
              </Typography>

            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-instructions/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Essentials
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      General Form 2290 instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Overview of Form 2290 filing requirements, key deadlines, and step-by-step filing instructions.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Read 2290 Instructions
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-due-dates/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Important dates
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Form 2290 due date
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Understand Form 2290 due dates based on when your vehicle is first used on public highways.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Due dates
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-schedule-1/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Most helpful
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Form 2290 Schedule 1
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn what Form 2290 Schedule 1 is, why you need it, and how to get your IRS-stamped Schedule 1 copy.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About Schedule 1
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-taxable-gross-weight-and-weight-categories/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Most helpful
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Gross weight & categories
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      How to determine your vehicle’s taxable gross weight and select the correct Form 2290 category.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Weight Categories
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-taxable-suspended-vehicles/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >



                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Taxable & suspended vehicles

                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn which vehicles are subject to HVUT, and which may qualify for suspended or exempt treatment.

                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Read More
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box component="section" sx={{ my: 8 }} >
        <Container maxWidth="lg">
          <Grid container spacing={3} rowSpacing={4} m={0} sx={{ justifyContent: 'center' }} >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Payment Options & Mobile App

              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }} >
                Explore convenient ways to pay your Form 2290 tax and file from your mobile device.
              </Typography>

            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-irs-payment-options/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'space-around', alignItems: 'center', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12
                  }} >
                    Payment
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Payment options & methods
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Compare available IRS payment methods and choose the option that works best for your filing.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Explore Payment Options
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/filing-form-2290-through-the-mobile-app/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'space-around', alignItems: 'center', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12
                  }} >
                    Technology
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Mobile app filing
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn how to file Form 2290 from your phone with a simple, mobile-friendly filing experience.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About Mobile Filing
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>

          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }} >
        <Container maxWidth="lg" sx={{ py: 8 }} >
          <Grid container spacing={3} rowSpacing={4} m={0} sx={{ justifyContent: 'center' }} >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Penalties, Credits & Amendments


              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }} >
                Understand what happens when you file late, qualify for a credit, or need to correct a previously filed return.
              </Typography>

            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/hvut-form-2290-penalties/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Compliance
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      HVUT penalties explained
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn about Form 2290 late-filing and late-payment penalties and how to avoid unnecessary charges.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About Penalties
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-credit-vehicles/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Credits & deductions
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Form 2290 Credit Vehicles
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Find out when you may qualify for a credit or refund due to a vehicle sale, destruction, theft, or other qualifying event.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About Credits
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-amendments/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Corrections
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Filing amendments
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn when you need to amend Form 2290 and how to correct vehicle or tax information.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Explore Amendments
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>

          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#fff' }} >
        <Container maxWidth="lg" sx={{ py: 8 }} >
          <Grid container spacing={3} rowSpacing={4} m={0} sx={{ justifyContent: 'center' }} >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Guides for Filers



              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }} >
                Get resources tailored to different types of truck owners, operators, and transportation businesses.
              </Typography>

            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-filing-guide-for-owner-operators/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Most helpful
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Owner-Operator Guide
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      A practical guide for owner-operators covering Form 2290 taxable vehicles, exemptions, and filing requirements.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Owner-Operator Guide
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/form-2290-filing-guide-for-fleet-managers/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Most helpful
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Fleet Managers
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Understand how to manage Form 2290 filings across multiple vehicles and keep your fleet records organized.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Fleet Manager Guide
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link href="/resources/excise-tax/automagic2290/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Feature
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      AutoMagic2290
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Want to simplify your Form 2290 filing? Learn how AutoMagic2290 uses your prior-year IRS-stamped Schedule 1 to fill in your entire return automatically.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Explore AutoMagic2290
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              {/* <Link href="/resources/excise-tax/form-2290-amendments/" sx={{ textDecoration:'none'}} > */}
              <Paper variant="outlined" sx={{
                px: 2, position: 'relative', backgroundColor: "#f9f9f9", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                  // transform: 'rotate(-225deg)',
                },
                '&:hover': {
                  boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                  transform: 'translateY(-0.1rem)',
                }

              }} >
                <Typography variant="body1" sx={{
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                  zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                }} >
                  FREE Template
                </Typography>

                <Box>
                  <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                    Bulk Upload Template
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 3 }} >
                    Use our Form 2290 bulk upload template to prepare vehicle details and upload multiple vehicles at once.
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                  <Typography variant="body1"  >
                    Download
                  </Typography>
                  <FileDownloadOutlinedIcon sx={{ transform: 'rotate(0deg)', transition: 'transform 0.3s ease', }} />

                </Box>


              </Paper>
              {/* </Link> */}
            </Grid>

          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }} >
        <Container maxWidth="lg" sx={{ py: 8 }} >
          <Grid container spacing={3} rowSpacing={4} m={0} sx={{ justifyContent: 'center' }} >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                State-Specific Taxes & Registration



              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }} >
                Explore state-level taxes and registration requirements that may apply in addition to federal Form 2290 filings.
              </Typography>

            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/new-york-hut/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    State-specific
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      New York HUT
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn about New York's Highway Use Tax and how it differs from federal Form 2290 requirements.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About New York HUT
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/kentucky-form-2290/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    State-specific
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Kentucky Form 2290
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Understand Kentucky-specific requirements related to Form 2290 and heavy vehicle registration.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Kentucky Guide
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/kansas-form-2290/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    State-specific
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Kansas Form 2290
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Get guidance on Kansas requirements and how Form 2290 documentation may affect vehicle registration.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      View Kansas Guide
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/irp/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Registration
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      International Registration Plan (IRP)
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Understand how Form 2290 and Schedule 1 relate to IRP registration and vehicle requirements.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About IRP
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link href="/resources/excise-tax/unified-carrier-registration/" sx={{ textDecoration: 'none' }} >
                <Paper variant="outlined" sx={{
                  px: 2, position: 'relative', backgroundColor: "#fff", borderRadius: 3, pt: 3, pb: 2, minHeight: '100%', justifyContent: 'center', display: 'grid', alignContent: 'space-between', transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                    transform: 'rotate(-225deg)',
                  },
                  '&:hover': {
                    boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                    transform: 'translateY(-0.1rem)',
                  }

                }} >
                  <Typography variant="body1" sx={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                    zIndex: 2, position: 'absolute', fontSize: { md: 13, sm: 12, xs: 11 }, borderRadius: 24, backgroundColor: '#e7f8ed', color: '#1da94a', fontWeight: 500, border: '1px solid #1da94a', px: 2, display: 'inline-block', top: -12, left: 15
                  }} >
                    Registration
                  </Typography>

                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 600, fontSize: { md: 22, sm: 19, xs: 16 }, mb: 0.5 }} >
                      Unified Carrier Registration (UCR)
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }} >
                      Learn about UCR requirements for interstate motor carriers and how they fit into your compliance responsibilities.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', textAlign: 'left', mt: 2, gap: 1.2, color: '#0202ff' }} >

                    <Typography variant="body1"  >
                      Learn About UCR
                    </Typography>
                    <KeyboardBackspaceIcon sx={{ transform: 'rotate(-180deg)', transition: 'transform 0.3s ease', }} />

                  </Box>


                </Paper>
              </Link>
            </Grid>

          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }} component={'section'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Need Help Filing Form 2290?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              Have the information you need? File Form 2290 online with a guided e-filing experience and get <br /> your IRS-stamped Schedule 1 quickly.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excisetax`}
              >
                E-File Form 2290
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default ExciseTax;
